import axios, { type AxiosRequestConfig } from 'axios';

export default async (customAgentId: string) => {
  const config: AxiosRequestConfig = {
    url: `/custom_agent/${customAgentId}`,
    method: 'delete',
  };

  await axios.request(config);
};
